export type AddressInfo = {
  city?: string
  country?: string
  cp?: string
  street?: string
}

/**
 * Address the patient saved from the patient app (booking / profile). Read-only in the
 * professional app. Note the field names differ from {@link AddressInfo}: `postalCode` (not `cp`),
 * plus delivery access details.
 */
export type SavedAddress = {
  _id: string
  label: string
  street: string
  city: string
  postalCode: string
  country: string
  apartment?: string
  floor?: string
  doorCode?: string
  instructions?: string
  placeId?: string
  coordinates?: { lat: number; lng: number }
  isDefault: boolean
}

export type ContactInfo = {
  city?: string
  country?: string
  cp?: string
  phone?: string
  street?: string
}

export type Gender = 'F' | 'M' | 'I'

export enum KeycloakUserType {
  ADMIN = 'ADMIN',
  PATIENT = 'PATIENT',
  STAFF = 'STAFF',
}

export type Period = {
  open: number
  close: number
}

export enum Role {
  Netsoins = 'Netsoins',
  Auth = 'Auth',
  Staff = 'Staff',
  ItSupport = 'Support IT',
  Room = 'Room',
  Files = 'Files',
  Consultation = 'Consultation',
  Patient = 'Patient',
  Parent = 'Parent',
  Charge = 'Charge',
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  CustomDevices = 'CustomDevices',
}

export type Timestamps = {
  createdAt: string
  updatedAt: string
}

export type UserInfo = {
  birthday?: string
  gender?: Gender
  name: string
  surname: string
  username?: string
  language?: string
  /** Preferred IANA timezone for notifications, e.g. 'Europe/Paris'. Set from the browser on first connection. */
  notificationTimezone?: string
}

export type WithId<T> = T & { id: string }
